import type { FaireProductEntity } from "../../entity_types/product";

export const p_c44mef75hn: FaireProductEntity = {
  token: "p_c44mef75hn",
  type: "product",
  name: "Saltwater Jasmine– Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/7e700a0c8e7aef53e9bff404305736c2e9157e38948f2a7e838c9566a3342b07.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bb1c31b454ee04a282eb3a034c79f02599a72bccbfc1378bb4c8b29923b206e5.jpeg",
    "https://cdn.faire.com/fastly/3b94199146264f2e2101dd20c4f1d4e6cb288024ec4b4152cf1cadc7eef6bc50.png",
    "https://cdn.faire.com/fastly/bb8ef4478a49eb7b2744d43b1e2e634ea7eefdafb808101270f50e60a94241f3.png",
    "https://cdn.faire.com/fastly/a9cd7a88ff9a2cd4d5a92f60c18da2538dc97119c8ea77ddd5099c5cf3ab1709.jpeg",
    "https://cdn.faire.com/fastly/eacd7956b4db25f2c062e4db4504dc0525a11176bdd94435c712d1c5b79eb160.jpeg",
  ],
  priceDollars: 14.5,
  description:
    '*NEW* Coastal mornings blanketed in a gentle marine layer, the warmth of the rising sun, wild white blossoms collecting dew. Ozonic, crisp, clean, with bergamot, muguet, sea moss, and sandalwood.\n\nLow-maintenance, flame-free, and always-on scent for entry ways, bathrooms, dorm rooms, and bedrooms.\n\nEach diffuser contains a 3.5 fl oz blend of naturally-derived and man-made fragrance oils in a 4 oz amber apothecary-inspired bottle. Includes a bundle of 9" long naturally-harvested rattan reeds to absorb and slowly release the fragrance. \n\nLasts approximately 3-4 months, flip reeds weekly.\n',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:58.958Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
